import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/BouwInvest-Frontend/src/components/molecules/previewModeBanner/previewModeBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContentBlocks"] */ "/home/vsts/work/1/s/BouwInvest-Frontend/src/components/organisms/contentBlocks/ContentBlocks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/BouwInvest-Frontend/src/components/pages/fundsDetailPage/FundsDetailPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/BouwInvest-Frontend/src/components/pages/fundsDetailPage/FundsDetailPageFactory.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageWrapper"] */ "/home/vsts/work/1/s/BouwInvest-Frontend/src/components/pages/pageWrapper/PageWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/BouwInvest-Frontend/src/components/pages/searchPage/SearchPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/BouwInvest-Frontend/src/components/pages/searchPage/SearchPageFactory.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientEnvironmentContext"] */ "/home/vsts/work/1/s/BouwInvest-Frontend/src/utils/globalConfig/clientEnvironmentContext.tsx");
